// src/pages/settings/AssignMicroapp.js
import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import API_BASE_URL from "../../config";
import axios from "axios";
import { Link } from "react-router-dom";
import Select from "react-select";

// Same department structure from Header.js
const departments = [
  {
    id: "crm",
    title: "CRM",
    apps: [
      { id: "crm_add_lead", label: "Add Lead" },
      { id: "crm_view_lead", label: "View Lead" },
      { id: "crm_edit_lead", label: "Edit Lead" },
    ],
  },
  {
    id: "invoicing",
    title: "Invoicing",
    apps: [
      { id: "inv_create_pi", label: "Create Proforma" },
      { id: "inv_view_pi", label: "View Proforma" },
      { id: "inv_edit_pi", label: "Edit Proforma" },
      { id: "inv_create_tax_standalone", label: "Standalone Tax Invoice" },
      { id: "inv_create_tax_from_pi", label: "Tax Invoice Against PI" },
      { id: "inv_view_tax", label: "View/Edit Tax Invoice" },
    ],
  },
  {
    id: "settings",
    title: "Settings",
    apps: [
      { id: "settings_add_user", label: "Add User" },
      { id: "settings_view_user", label: "View User" },
      { id: "settings_assign_microapp", label: "Assign Microapp" },
    ],
  },
];

const AssignMicroapp = () => {
  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [selectedApps, setSelectedApps] = useState([]);

  useEffect(() => {
    document.title = "Assign Microapp | Webyappy";
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/auth/get_users_list`);
      setUsers(res.data);
    } catch (err) {
      console.error("Failed to fetch users:", err);
    }
  };

  const handleCheckboxChange = (appId) => {
    if (selectedApps.includes(appId)) {
      setSelectedApps(selectedApps.filter((id) => id !== appId));
    } else {
      setSelectedApps([...selectedApps, appId]);
    }
  };

  const handleUserChange = (e) => {
    const userId = e.target.value;
    setSelectedUserId(userId);
    setSelectedApps([]); // Reset microapps for now (will update in Step 2 with API)
  };

const handleAssign = async () => {
  if (!selectedUserId || isSubmitting) return;

  setIsSubmitting(true);

  try {
    const res = await axios.post(`${API_BASE_URL}/auth/assign_user_microapps`, {
      user_id: selectedUserId,
      microapps: selectedApps,
    });

    if (res.data.status === "success") {
      alert("Microapps assigned successfully!");
    } else {
      alert("Error: " + res.data.message);
    }
  } catch (err) {
    console.error("Assignment failed:", err);
    alert("Something went wrong while assigning microapps.");
  } finally {
    setIsSubmitting(false);
  }
};


const [isSubmitting, setIsSubmitting] = useState(false);




  return (
    <>
      <Header />
      <div style={{ paddingTop: "70px", paddingBottom: "70px" }}>
        <div className="container-fluid px-3 py-3">
          {/* Breadcrumb */}
          <div className="d-flex align-items-center justify-content-between mb-4">
            <ul className="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold mb-0 p-0">
              <li className="breadcrumb-item">
                <Link to="/home" className="text-muted">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/pages/settings/Settings" className="text-muted">
                  Settings
                </Link>
              </li>
              <li className="breadcrumb-item">
                <span className="text-dark font-weight-bold">
                  Assign Microapp
                </span>
              </li>
            </ul>
          </div>

          {/* Select User Dropdown */}
          <div className="form-group mb-4">
            <label className="font-weight-bold">Select User</label>
            <Select
              className="shadow-sm"
              options={users.map((user) => ({
                value: user.id,
                label: `${user.name} (${user.email})`,
              }))}
              onChange={async (selectedOption) => {
              const userId = selectedOption ? selectedOption.value : "";
              setSelectedUserId(userId);
              setSelectedApps([]);

              if (userId) {
                try {
                  const res = await axios.get(`${API_BASE_URL}/auth/get_user_microapps`, {
                    params: { user_id: userId },
                  });
                  if (res.data.status === "success") {
                    setSelectedApps(res.data.microapps); // Pre-check assigned apps
                  }
                } catch (err) {
                  console.error("Error fetching assigned microapps:", err);
                }
              }
            }}

              placeholder="-- Select User --"
              isClearable
            />
          </div>

          {/* Microapp Cards */}
          {selectedUserId && (
            <div className="row">
  {departments.map((dept) => (
    <div key={dept.id} className="col-xl-4 col-lg-6 col-md-6 mb-4">
      <div className="card shadow-sm h-100">
        <div className="card-header font-weight-bold bg-light">
          {dept.title}
        </div>
        <div className="card-body">
          {dept.apps.map((app) => (
            <div key={app.id} className="form-check mb-2">
              <input
                type="checkbox"
                className="form-check-input"
                id={`${dept.id}_${app.id}`}
                checked={selectedApps.includes(app.id)}
                onChange={() => handleCheckboxChange(app.id)}
              />
              <label
                className="form-check-label"
                htmlFor={`${dept.id}_${app.id}`}
              >
                {app.label}
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  ))}

  {/* Assign button centered below all cards */}
  <div className="col-12 text-center mt-3">
    <button
      className="btn btn-primary"
      onClick={handleAssign}
      disabled={isSubmitting}
    >
      {isSubmitting ? (
        <>
          <span
            className="spinner-border spinner-border-sm mr-2"
            role="status"
            aria-hidden="true"
          ></span>
          Assigning...
        </>
      ) : (
        <>
          <i className="fas fa-check fa-xs mr-1"></i> Assign
        </>
      )}
    </button>
  </div>
</div>

          )}

          

        </div>
      </div>
    </>
  );
};

export default AssignMicroapp;
